import { GridEvents, GridScrollParams, MuiBaseEvent, MuiEvent } from '@mui/x-data-grid-pro';
import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import { useNavHeightContext } from 'common/contexts/NavHeightContext';
import * as React from 'react';

interface Props {
  dataGridApiRef: React.RefObject<GridApiPro>;
  isFixedHeaders: boolean;
  stylesOverride?: object;
}

export const ExtraScrollBar = ({ dataGridApiRef, isFixedHeaders, stylesOverride }: Props) => {
  const { marginTop } = useNavHeightContext();
  React.useEffect(() => {
    if (!dataGridApiRef || !dataGridApiRef.current) {
      return;
    }
    dataGridApiRef.current.subscribeEvent(
      GridEvents.rowsScroll,
      (
        params: GridScrollParams, // GridScrollParams
        event: MuiEvent<React.UIEvent | MuiBaseEvent> // MuiEvent<React.UIEvent | MuiBaseEvent>
      ) => {
        if ('type' in event && event.type === 'scroll') {
          event.preventDefault();
          const extraScrollbarWrapper = document.getElementById('extra-scrollbar-wrapper');
          if (!extraScrollbarWrapper) {
            return;
          }
          extraScrollbarWrapper.scrollLeft = params.left;
        }
      }
    );
    dataGridApiRef.current.subscribeEvent(GridEvents.virtualScrollerContentSizeChange, () => {
      const virtualScroller = document.getElementsByClassName(
        'MuiDataGrid-virtualScrollerContent'
      )[0];
      const extraScrollbar = document.getElementById('extra-scrollbar');

      if (!extraScrollbar) {
        return;
      }
      extraScrollbar.style.width = `${virtualScroller.clientWidth}px`;
    });
  }, [dataGridApiRef]);

  const handleOnScroll = (e: React.UIEvent<HTMLElement>) => {
    const virtualScroller = document.getElementsByClassName('MuiDataGrid-virtualScroller')[0];
    virtualScroller.scrollLeft = e.currentTarget.scrollLeft;
  };
  let style = {};
  if (isFixedHeaders) {
    style = {
      top: marginTop,
      left: '1px',
      zIndex: 499, // Container details page is 500
      position: 'fixed',
    };
  }

  style = { ...style, ...stylesOverride };

  return (
    <div
      id="extra-scrollbar-wrapper"
      className="w-full h-4  overflow-x-scroll scrollbar"
      onScroll={handleOnScroll}
      style={style}
    >
      <div id="extra-scrollbar" />
    </div>
  );
};
